



































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import UiList from '@superUI/List/List'
import Modal from '@/components/Modal'

settings =
  name: 'VariablesList'
  components: { SuperContainerView, UiList, Modal }
  resources:
    variables:
      resourceName: 'variables'
      slug: 'marketplace/settings/variables'
      infinityScroll: false

  vue:
    data: ->
      editModal:
        objectId: null
        label: ''
        fieldName: null
        value: null
        fieldType: ''
        options: null
        show: false
        resourceName: null
        resourceSlug: null
        onChange: null
    methods:
      editField: (objectId, label, fieldName, value, fieldType, options) ->
        @editModal.objectId = objectId
        @editModal.label = label
        @editModal.fieldName = fieldName
        @editModal.value = value
        @editModal.fieldType = fieldType
        @editModal.options = options
        @editModal.onChange = @saveField
        @editModal.resourceName = 'variable'
        @editModal.resourceSlug = "marketplace/settings/variables/#{objectId}"
        @editModal.show = true

      saveField: ->
        payload = {}
        payload.id = @editModal.objectId
        payload[@editModal.fieldName] = @editModal.value
        @save("marketplace/settings/variables/#{@editModal.objectId}", 'variable', payload)

      onSave: (item) ->
        @fetchAllResources()
        @editModal.show = false

export default VueOptions.vue settings
